<template>
	<div class="main-containter" id="top" v-title data-title="和华利盛">
		<FHeader :checkId="23"></FHeader>
		<FOtherBanner :name1="'关于我们'" :name2="'About Us'"></FOtherBanner>
		<!-- <FTitle></FTitle> -->
		<article style="height: 520px;">
			<div style="padding-left: 18%;padding-top: 20px;">
				<el-breadcrumb separator="/">
				<el-breadcrumb-item :to="{ path: '/' }" style="cursor: pointer;">首页</el-breadcrumb-item>
				<el-breadcrumb-item style="cursor: default;">关于我们</el-breadcrumb-item>
				<el-breadcrumb-item style="cursor: default;color:black">荣誉奖项</el-breadcrumb-item>
			</el-breadcrumb>
			</div>
			<div style="width: 64%;padding: 30px 18%;margin-top:50px;position: absolute;">
				<div style="text-align: center;">
					<div style="font-size: 26px;font-weight: 900;color: #98273A;">荣誉奖项</div>
					<div style="padding-top: 5px;font-size: 14px;color: #98273A;">Honorary Awards</div>
				</div>
				<div style="padding-top:30px;">
					<div :style="{float:'left',width:'45%','margin-right':index%2==0?'5%':'0%','margin-left':index%2!=0?'5%':'0%',height:'40px','padding-top':'65px','border-bottom':'1px solid #98273A'}" v-for="(item,index) in list" :key="index">
						<span style="width: 4px;height: 4px;background-color: #98273A;display: inline-block;margin-bottom: 3px;margin-right: 10px;margin-left: 10px;"></span>
						<span style="color: #98273A;font-size:14px;">{{item}}</span>
					</div>
				</div>
			</div>
		</article>
		<Footer></Footer>
	</div>
</template>

<script>
	import FHeader from "../../components/f/FHeader.vue"
	import FOtherBanner from "../../components/f/FOtherBanner.vue"
	import Footer from "../../components/f/Footer.vue"

	import {queryScenicList,querySoftwareList,queryArticleList} from "@/api/front";
	export default {
		name: "Index",
		components: {
			FHeader,
			FOtherBanner,
			Footer
		},
		data() {
			return {
				list: ['世博推荐法律服务供应商',
				'上海市优秀律师事务所',
				'最值得关注的10家律师事务所'

                ],
			}
		},
		mounted() {
		},
		activated(){
			document.getElementById("top").scrollIntoView({ behavior: "smooth" });
		},
		
		watch: {
		},
		methods: {
		}
	}
</script>
<style lang="scss" scoped="scoped">


	span /deep/ .el-breadcrumb__inner{
		font-weight: 400 !important;
		color: #606266 !important;
		cursor: default !important;
	}
	span /deep/ .el-breadcrumb__inner.is-link{
		font-weight: 400 !important;
		color: #606266 !important;
		cursor: pointer !important;
	}
	.middle{
		background: url('https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/adoutUsMiddle.png') no-repeat;
		background-size:100% 100%;
		width: 100%;
		height: 300px;
		margin-bottom: 70px;
		margin-top: 100px;
	}
	.aboutContent{
		width: 64%;
		padding: 30px 18%;
		padding-top: 50px;
		display: flex;
		flex-direction: row;
		// justify-content: space-between;
		.left{
			width: 61%;
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			.cmpName{
				width: 100%;
				height: 50px;
				font-size: 28px;
				font-family: Adobe Heiti Std R;
				color: #2E2E2E;
				line-height: 33px;
				border-bottom: 2px solid #469DFF;
			}
			.cmpInfo{
				width: 600px;
				padding: 10px 0;
				font-size: 21px;
				font-family: Adobe Heiti Std R;
				color: #838383;
				line-height: 33px;
			}
			.button{
				width: 120px;
				height: 36px;
				color: #FFFFFF;
				font-size: 16px;
				line-height: 36px;
				text-align: center;
				border-radius: 20px;
				background-color: #1A86FF;
				cursor: pointer;
				margin-top: 20px;
			}
		}
		.right{
		padding-left: 7%;
    height: 100%;
		}
	}
</style>
